import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-65025b08")

_pushScopeId("data-v-65025b08")
const _hoisted_1 = {
  class: "container",
  ref: "filterbody"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_BaseFilter = _resolveComponent("BaseFilter")

  return (_openBlock(), _createBlock(_component_BaseFilter, {
    name: _ctx.title,
    help: _ctx.help,
    filtering: _ctx.isFiltering,
    invertible: _ctx.invertible,
    collapsible: _ctx.collapsible,
    collapsed: _ctx.collapsed,
    onReset: _ctx.resetFilter,
    onFltSelectionInverted: _ctx.invertSelection
  }, {
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.categories, (value, idx) => {
          return (_openBlock(), _createBlock(_component_Checkbox, {
            key: idx,
            checked: _ctx.isChecked(value),
            value: value,
            inactive: !_ctx.isFiltering,
            onToggle: ($event: any) => (_ctx.toggle(idx, $event))
          }, {
            default: _withId(() => [
              _createVNode("span", null, _toDisplayString(value), 1)
            ]),
            _: 2
          }, 1032, ["checked", "value", "inactive", "onToggle"]))
        }), 128))
      ], 512)
    ]),
    _: 1
  }, 8, ["name", "help", "filtering", "invertible", "collapsible", "collapsed", "onReset", "onFltSelectionInverted"]))
})